import { Alert, AlertDescription, AlertIcon, AlertTitle, Box, Stack } from '@chakra-ui/react';
import { MindbodyContract } from 'types/contract';
import {
  formatMonthYearFR,
  isCardValidThroughContractEngagement,
  StoredCardExp,
} from 'screens/Checkout/utils/cardExpirationCheck';

export interface SavedCardExpirationAlertProps {
  card: StoredCardExp & { LastFour?: string };
  contract: MindbodyContract;
}

/**
 * Affiché en mode `variant='contract'` quand la carte stockée du client
 * expire avant la fin de l'engagement minimum du contract. Bloquant : le
 * caller (CheckoutForm) doit également désactiver le radio "carte stockée"
 * et forcer l'utilisateur à saisir une nouvelle carte.
 *
 * Renvoie null quand la carte est valide ou qu'on ne peut pas calculer
 * (info manquante côté contract ou carte).
 */
export function SavedCardExpirationAlert({ card, contract }: SavedCardExpirationAlertProps) {
  const check = isCardValidThroughContractEngagement(card, contract);
  if (!check || check.valid) return null;

  const last4 = card.LastFour ? ` se terminant par ${card.LastFour}` : '';

  return (
    <Box my={4}>
      <Alert status="warning" variant="left-accent" borderRadius="md" alignItems="flex-start">
        <AlertIcon mt={1} />
        <Stack spacing={1}>
          <AlertTitle fontSize="sm">Carte enregistrée bientôt expirée</AlertTitle>
          <AlertDescription fontSize="sm" lineHeight="1.5">
            Votre carte enregistrée{last4} expire en{' '}
            <strong>{formatMonthYearFR(check.cardExpiresAt)}</strong>, mais l'engagement de cet abonnement court
            jusqu'en <strong>{formatMonthYearFR(check.endEngagement)}</strong>. Pour éviter l'échec d'un prélèvement
            en cours d'engagement, merci d'utiliser une nouvelle carte bancaire ci-dessous.
          </AlertDescription>
        </Stack>
      </Alert>
    </Box>
  );
}
